<template lang="pug">
  div.modal(:style="styles")
    slot
</template>

<script>
  const SwbcSales = window.SwbcSales
  export default {
    name: 'SwbcSalesFrame',
    props: {
      visible: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      styles () {
        return {
          display: this.visible ? '' : 'none'
        }
      }
    }
  }
</script>

<style lang="sass">
  .modal
    position: fixed
    z-index: 1000
    top: 0
    left: 0
    width: 100vw
    height: 100vh
</style>
